import getConfig from 'next/config';

import logger from '@sravni/server-utils/lib/logger';
import { createClient } from '@sravni/ugc/lib/client';

import { isServer } from '../../utils/isServer';

const url = isServer
  ? `${process.env.INTERNAL_WEB_PATH}${process.env.API_PATH}`
  : getConfig().publicRuntimeConfig.apiPathUrl;

export const ProxyClient = createClient(url, { sentryErrorTagName: 'rating-frontend-proxy', logger });
